import styled from "styled-components";

export const RoadmapContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  column-gap: 1.25rem;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100px;
    background: linear-gradient(
      to left,
      ${(props) => props.theme.colors.lightest},
      transparent
    );
    pointer-events: none;
    z-index: 1;
  }
`;

export const RoadmapRowWrapper = styled.div`
  grid-column: span 12;
  display: grid;
  grid-template-columns: 110px 1fr;
  grid-column-gap: 1.25rem;
  border-top: 2px solid ${(props) => props.theme.colors.light};

  &:first-child {
    border-top: none;
  }
`;

export const RoadmapRow = styled.div`
  padding: 1rem 3rem 1rem 1rem;
  grid-column: 2 / -1;
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: 300px;
  grid-column-gap: 1.25rem;
  overflow-x: auto;

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const ProductRowHeader = styled.div`
  grid-column: span 1;
  display: flex;
  align-items: center;
  font-size: 1rem;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    right: -30px;
    bottom: 0;
    width: 20px;
    background: linear-gradient(
      to right,
      ${(props) => props.theme.colors.lightest},
      ${(props) => props.theme.colors.lightest} 50%,
      transparent
    );
    pointer-events: none;
    z-index: 1;
  }
`;
